/* import __COLOCATED_TEMPLATE__ from './three-columns-image-text.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();